import { readUrl, getResource } from "./api";

// Conferred badges. The endpoint returns only active rows, so a row coming back IS the badge being
// held; there is no flag to read on it. Read-only — badges are conferred server side.

/**
 * The badges of one kind held by one owner. At most one row comes back: a kind is unique per owner.
 *
 * @param {string} kind - Badge kind, e.g. "qwoted100"
 * @param {string} ownerType - Owner model name, e.g. "Id::Profile::Promoter"
 * @param {string|number} ownerId
 * @returns {Promise<{data: Array, error?: object}>}
 */
const getForOwner = async (kind, ownerType, ownerId) => {
  const selector = `kind=eq.${encodeURIComponent(kind)}&owner_type=eq.${encodeURIComponent(
    ownerType,
  )}&owner_id=eq.${ownerId}`;
  const url = readUrl("badges", { selector });
  return getResource(url);
};

export default {
  getForOwner,
};
